import { render, staticRenderFns } from "./ChatbotMenuItem.vue?vue&type=template&id=61439815"
import script from "./ChatbotMenuItem.vue?vue&type=script&lang=js"
export * from "./ChatbotMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports